import React, { Component, PropTypes } from 'react'
import classNames from 'classnames'
import PaintSwatch from './PaintSwatch'
import PaintFillGrid from './PaintFillGrid'

class PaintFillChooser extends Component {
  constructor(props) {
    super();
    if(props.isOpen)
      this.state = { hidden: false }
    else  
      this.state = { hidden: true }
  }

  toggle() {
    this.setState({ hidden: !this.state.hidden });
  }

  onSelectPaintFill(paint) {
    this.props.onSelectPaintFill(paint);
    this.setState({ hidden: true });
  }

  render() {
    const { loc, selectedPaint, paints, labelOverride, isError } = this.props;
    return (
      <div className={classNames("paintfill-chooser", { "error" : isError })}>
        <div className="paintfill-selection" onClick={() => this.toggle()}>
          {labelOverride &&
            loc.label.replace('Line', labelOverride)}
          {!labelOverride &&
            loc.label}
          <PaintSwatch paint={selectedPaint} />
        </div>
        <PaintFillGrid
          className={classNames({ 'hidden': this.state.hidden })}
          paints={paints}
          selectedPaint={selectedPaint}
          onSelectPaintFill={(paint) => this.onSelectPaintFill(paint)} />
      </div>
    )
  }
}

PaintFillChooser.defaultProps = {
  isError: false
}

PaintFillChooser.propTypes = {
  loc: PropTypes.object.isRequired,
  selectedPaint: PropTypes.object,
  paints: PropTypes.arrayOf(PropTypes.object).isRequired,
  labelOverride: PropTypes.string,
  isOpen: PropTypes.bool,
}

export default PaintFillChooser